import { Box } from "@mui/material";
import { createFileRoute, useParams } from "@tanstack/react-router";

import {
  PEOPLE_DIMENSIONS_DASHBOARD_ID,
  PEOPLE_DIMENSIONS_FILTER_ID,
} from "@/api/dimensions/constants";
import { LoadingFallback } from "@/components/LoadingFallback";
import { DimensionsOmniIframe } from "@/features/Dimensions/DimensionsOmniIframe";

export const Route = createFileRoute("/_auth/dimensions/$siteId/people")({
  component: RouteComponent,
  pendingComponent: LoadingFallback,
});

function RouteComponent() {
  const { siteId } = useParams({ from: "/_auth/dimensions/$siteId/people" });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <DimensionsOmniIframe
        siteId={siteId}
        dashboardId={PEOPLE_DIMENSIONS_DASHBOARD_ID}
        filterId={PEOPLE_DIMENSIONS_FILTER_ID}
        title="Dimensions — People"
      />
    </Box>
  );
}
